import { VoidCallback } from 'types/callbacks';
import { CommunityShotItem } from 'types/community';

import styles from './RemixButton.module.css';

type Props = {
  shotItem: CommunityShotItem;
  onClick: VoidCallback;
};

const RemixButton = ({ shotItem, onClick }: Props) => {
  return (
    <div className={styles.Container} onClick={onClick}>
      <div className={styles.Title}>Remix</div>
      <div className={styles.Label}>
        {shotItem.publishedRemixCount > 0 && (
          <div className={styles.Count}>{shotItem.publishedRemixCount}</div>
        )}
      </div>
    </div>
  );
};

export default RemixButton;
